// extracted by mini-css-extract-plugin
export var container = "styles-module__container___YOHPN";
export var collapsible = "styles-module__collapsible___AxZEk";
export var collapsed = "styles-module__collapsed___mJUju";
export var control = "styles-module__control___n_lX5";
export var title = "styles-module__title___Ru_gD";
export var toggleButton = "styles-module__toggleButton___hf0fO";